<template>
  <div
    :renderKey="renderKey"
    v-if="showActionButtons()"
    class="text-center actions-container"
  >
    <v-tooltip v-for="(action, index) in allActions(true)" :key="index" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          v-show="!actionHidden(action)"
          :icon="!action.showCaption"
          :elevation="elevation"
          :disabled="actionDisabled(action)"
          :x-small="small"
          :large="large"
          :dark="dark"
          :light="light"
          @click="callAction({ action, coordinates })"
        >
          <v-icon>{{ action.icon }}</v-icon>
          <span v-if="action.showCaption">{{
            translatedConfig(
              generalExApplicationEx,
              customLanguage,
              action,
              "caption"
            )
          }}</span>
        </v-btn>
      </template>
      <span>{{
        translatedConfig(
          generalExApplicationEx,
          customLanguage,
          action,
          "caption"
        )
      }}</span>
    </v-tooltip>
    <v-menu
      v-model="actionMenu"
      :close-on-content-click="true"
      :nudge-width="200"
      offset-y
      :dark="dark"
      :light="light"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-if="showOthers()"
          icon
          v-bind="attrs"
          v-on="on"
          :x-small="small"
        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-list> </v-list>

        <v-list>
          <div v-for="(action, index) in allActions(false)" :key="index">
            <v-list-item
              link
              @click="callAction({ action, coordinates })"
              :disabled="actionDisabled(action)"
            >
              <v-list-item-action>
                <v-list-item-action-text no-action>
                  <v-icon>{{ action.icon }}</v-icon>
                  {{
                    translatedConfig(
                      generalExApplicationEx,
                      customLanguage,
                      action,
                      "caption"
                    )
                  }}
                </v-list-item-action-text>
              </v-list-item-action>
            </v-list-item>
          </div>
        </v-list>

        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "Actions",
  data() {
    return {
      actionMenu: false,
    };
  },
  props: [
    "show",
    "types",
    "method",
    "actions",
    "generalExApplicationEx",
    "customLanguage",
    "coordinates",
    "color",
    "light",
    "dark",
    "elevation",
    "changed",
    "queryChanged",
    "small",
    "large",
    "data",
    "position",
    "renderKey",
  ],
  methods: {
    showActionButtons() {
      return this.show && this.allActions().length > 0;
    },

    allActions(preview) {
      return this.selectActions({
        actions: this.actions,
        types: this.types,
        transactionMethod: this.transactionMethod,
        preview,
        position: this.position,
        data: this.data,
      });
    },

    showOthers() {
      return this.selectOthers({
        actions: this.actions,
        types: this.types,
        method: this.method,
        position: this.position,
        data: this.data,
      });
    },

    callAction(params) {
      this.$emit("call-action", params);
    },

    actionDisabled(action) {
      let result = false;
      if (["bulkCheck", "bulkDynamic"].includes(action.type)) {
        result = !this.changed;
      }
      if (["bulkContent"].includes(action.type) && !action.accessFormula) {
        result = !this.queryChanged;
      }

      /*
      if (this.notBlank(action.accessFormula)) {
        const data = this.data;
        result = !eval(action.accessFormula, data);
      }
      */

      return result;
    },
    actionHidden(action) {
      if (["dynamic"].includes(action.type)) {
        return this.actionDisabled(action);
      } else {
        return false;
      }
    },
  },
  updated() {},
};
</script>

<style scoped>
.actions-container {
  display: inline-block;
}
</style>